import type { EntitySnapshot, GameSnapshot, ObstacleKind, RunnerConfig } from './types';

interface VerticalBounds {
  readonly min: number;
  readonly max: number;
}

const OBSTACLE_BOUNDS: Readonly<Record<ObstacleKind, VerticalBounds>> = {
  barrier: { min: 0, max: 0.9 },
  beam: { min: 0.95, max: 2.4 },
  blocker: { min: 0, max: 2.6 },
};

export function crossedPlayerDepth(
  previousZ: number,
  currentZ: number,
  entityDepth: number,
  playerDepth: number,
): boolean {
  const previousFront = previousZ + entityDepth / 2;
  const currentBack = currentZ - entityDepth / 2;
  return previousFront >= -playerDepth / 2 || currentBack >= -playerDepth / 2;
}

export function overlapsPlayer(
  entity: EntitySnapshot,
  snapshot: Pick<GameSnapshot, 'player'>,
  config: RunnerConfig,
): boolean {
  // return false;
  const entityX = config.laneCenters[entity.lane];
  if (Math.abs(entityX - snapshot.player.x) >= config.laneCollisionWidth) return false;

  if (!crossedPlayerDepth(entity.previousZ, entity.z, 0.8, config.playerDepth)) return false;
  if (entity.previousZ - 0.4 > config.playerDepth / 2) return false;
  if (entity.z + 0.4 < -config.playerDepth / 2) return false;

  if (entity.kind === 'coin') return true;

  const playerMin = snapshot.player.y;
  const height =
    snapshot.player.action === 'sliding' ? config.slidingHeight : config.standingHeight;
  const playerMax = playerMin + height;
  const obstacle = OBSTACLE_BOUNDS[entity.kind];
  return playerMin < obstacle.max && playerMax > obstacle.min;
}
